<template>
  <svg class="icon"
       width="13"
       height="13"
       viewBox="0 0 13 13"
       fill="none"
       xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" fill="currentColor" d="M6.5 0C5.94772 0 5.5 0.447715 5.5 1V5.5H1C0.447715 5.5 0 5.94772 0 6.5C0 7.05228 0.447715 7.5 1 7.5H5.5V12C5.5 12.5523 5.94772 13 6.5 13C7.05228 13 7.5 12.5523 7.5 12V7.5H12C12.5523 7.5 13 7.05228 13 6.5C13 5.94771 12.5523 5.5 12 5.5H7.5V1C7.5 0.447715 7.05228 0 6.5 0Z" />
  </svg>
</template>

<script>
export default {
  name: 'Plus',
};
</script>
